import { app } from '../../../../app';

app.service('LoginRoleSelectModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (applicationId, accountId) => {
        return $uibModal.open({
            component: 'loginRoleSelect',
            resolve: {roles}
        }).result;

        /** @ngInject */
        function roles(LoginRolesService) {
            return LoginRolesService.query(applicationId, accountId);
        }
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/login-role-select/login-role-select.modal.js